<template></template>
<script>
import QueryMixin from './QueryMixin';
export default {
    name    :   'SortingMixin',
    mixins  :   [ QueryMixin ],
    data()
    {
        return {
            sort        :   this.$route.query.sort ? this.$route.query.sort : null,
            order       :   this.$route.query.order ? this.$route.query.order : null,
            sort_order  :   this.sort_order_maker()
        }
    },
    watch       :   {
        sort_order(nv, ov)
        {
            let me  =   this;
            switch (nv)
            {
                case 'n:z-a':
                    me.sort     =   'Title';
                    me.order    =   'DESC';
                    break;
                case 'p:l-h':
                    me.sort     =   'Price';
                    me.order    =   'ASC';
                    break;
                case 'p:h-l':
                    me.sort     =   'Price';
                    me.order    =   'DESC';
                    break;
                default:
                    me.sort     =   'Title';
                    me.order    =   'ASC';
            }

            this.$router.push({query: this.make_query(null, this.$route.name == 'SearchPage')});
        }
    },
    methods :   {
        sort_order_maker()
        {
            if (this.$route.query.sort == 'Title' && this.$route.query.order == 'DESC') {
                return 'n:z-a';
            }

            if (this.$route.query.sort == 'Price' && this.$route.query.order == 'ASC') {
                return 'p:l-h';
            }

            if (this.$route.query.sort == 'Price' && this.$route.query.order == 'DESC') {
                return 'p:h-l';
            }

            return 'n:a-z';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/SortingMixin.vue